export default {
  en: {
    home: 'Home',
    user: 'User',
    hotel: 'Hotel',
    agent: 'Agent',
    contract: 'Contract',
    specialOffer: 'Special Offer',
    email: 'Email',
    setting: 'Setting'
  },
  th: {
    home: 'หน้าหลัก',
    user: 'ผู้ใช้งาน',
    hotel: 'โรงแรม',
    agent: 'ตัวแทน',
    contract: 'สัญญา',
    specialOffer: 'ข้อเสนอพิเศษ',
    email: 'อีเมล',
    setting: 'การตั้งค่า'
  }
}
